module.exports = __webpack_public_path__ + "static/img/GU.6b5ef81b.svg";